<template>
  <div id="app">
    <div v-if="paytype" class="head-shadow">
      <div class="header head-lg">
        <div @click="refresh" class="cursor-pointer"><img height="70px" src="./assets/img/logo.png" alt=""></div>
        <ul class="ul-outer ul-header" style="font-size: 18px;text-decoration: none;padding:24px 0;">
          <li v-for="(item, index) in headerList" :key="item.label">
            <span :class="{ 'active': id == item.id }" class="hoverActive" @click="gotourl(item.url, index)">{{
              item.label }}</span>
          </li>
        </ul>
        <div class="expireTime">
          <div style="margin-right: 10px;height: 24px;">
            <svg t="1766369159843" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="9936" width="24" height="24">
              <path
                d="M0.118 512C0.118 794.684 229.284 1023.882 512 1023.882c282.688 0 511.882-229.2 511.882-511.882C1023.882 229.284 794.688 0.118 512 0.118 229.284 0.118 0.118 229.284 0.118 512z"
                fill="#FC6E51" p-id="9937"></path>
              <path
                d="M490.662 42.764c0 11.778 9.544 21.338 21.338 21.338 11.78 0 21.324-9.56 21.324-21.338 0-11.78-9.544-21.34-21.324-21.34-11.792 0-21.338 9.56-21.338 21.34zM490.662 981.206c0 11.778 9.544 21.338 21.338 21.338 11.78 0 21.324-9.56 21.324-21.338 0-11.78-9.544-21.308-21.324-21.308-11.792-0.002-21.338 9.528-21.338 21.308zM258.902 116.278c5.888 10.216 18.934 13.714 29.148 7.81 10.186-5.874 13.686-18.934 7.794-29.12-5.888-10.214-18.932-13.684-29.132-7.81-10.2 5.876-13.7 18.934-7.81 29.12zM728.138 929.03c5.874 10.184 18.934 13.684 29.12 7.81 10.214-5.906 13.714-18.934 7.808-29.15-5.872-10.216-18.932-13.684-29.118-7.81-10.214 5.904-13.682 18.932-7.81 29.15zM94.97 295.862c10.202 5.874 23.244 2.376 29.134-7.81 5.888-10.216 2.388-23.244-7.81-29.15-10.202-5.874-23.246-2.374-29.134 7.81-5.888 10.216-2.39 23.246 7.81 29.15zM907.692 765.066c10.216 5.904 23.246 2.406 29.148-7.81 5.876-10.186 2.376-23.246-7.808-29.12-10.218-5.904-23.246-2.406-29.15 7.81-5.906 10.186-2.408 23.248 7.81 29.12zM42.764 533.306c11.78 0 21.34-9.53 21.34-21.306 0-11.78-9.56-21.34-21.34-21.34-11.778 0-21.322 9.56-21.322 21.34 0 11.778 9.544 21.306 21.322 21.306zM981.208 533.306c11.808 0 21.338-9.53 21.338-21.306 0-11.78-9.53-21.34-21.338-21.34-11.748 0-21.308 9.56-21.308 21.34-0.002 11.778 9.558 21.306 21.308 21.306zM116.294 765.066c10.2-5.874 13.7-18.934 7.81-29.12-5.89-10.216-18.934-13.714-29.134-7.81-10.202 5.874-13.7 18.934-7.81 29.12 5.888 10.216 18.934 13.714 29.134 7.81zM929.032 295.862c10.184-5.904 13.684-18.934 7.808-29.15-5.902-10.184-18.932-13.684-29.148-7.81-10.216 5.906-13.714 18.934-7.81 29.15 5.904 10.184 18.93 13.682 29.15 7.81zM295.846 929.03c5.89-10.216 2.39-23.246-7.794-29.15-10.214-5.874-23.26-2.406-29.148 7.81-5.89 10.216-2.39 23.244 7.81 29.15 10.2 5.872 23.244 2.372 29.132-7.81z"
                fill="#E9573F" p-id="9938"></path>
              <path
                d="M512 128.088c-11.792 0-21.338 9.528-21.338 21.306v353.764L240.532 753.288a21.328 21.328 0 1 0 30.148 30.182L527.074 527.06a21.208 21.208 0 0 0 6.25-15.058V149.394c0-11.778-9.544-21.306-21.324-21.306z"
                fill="#434A54" p-id="9939"></path>
              <path
                d="M765.066 116.308c5.906-10.216 2.406-23.276-7.808-29.15-10.186-5.874-23.246-2.404-29.12 7.81-5.874 10.186-2.404 23.246 7.81 29.12 10.186 5.904 23.248 2.406 29.118-7.78z"
                fill="#E9573F" p-id="9940"></path>
              <path
                d="M1006.106 725.264c-32.898-75.296-108.068-127.972-195.516-127.972-87.45 0-162.622 52.676-195.52 127.972l-17.778 21.338v63.986c0 117.786 95.51 213.294 213.296 213.294 117.816 0 213.292-95.51 213.292-213.294v-63.986l-17.774-21.338z"
                fill="#F6BB42" p-id="9941"></path>
              <path
                d="M1023.882 746.602c0 117.786-95.476 213.294-213.292 213.294-117.788 0-213.296-95.51-213.296-213.294s95.51-213.294 213.296-213.294c117.816-0.002 213.292 95.508 213.292 213.294z"
                fill="#FFCE54" p-id="9942"></path>
              <path
                d="M810.59 661.278c-11.78 0-21.34 9.56-21.34 21.338v127.972c0 11.778 9.56 21.338 21.34 21.338 11.778 0 21.338-9.56 21.338-21.338v-127.972c0-11.778-9.56-21.338-21.338-21.338z"
                fill="#E8AA3D" p-id="9943"></path>
            </svg>
          </div>
          <span>{{ expireTime }}</span>
        </div>
        <div v-if="!gameName1" class="logins opacityhover08" @click="openLogin">Login</div>
        <div v-if="gameName1" style="position: relative;cursor: pointer;" @click="openInfo" class="info">{{ gameName1 }}
          <!-- <el-card v-if="isInfo" class="box-card">
            <div class="flex">
              <span class="mg-12">Username:</span>
              <span>{{ gameName1 }}</span>
            </div>
            <div class="flex">
              <span class="mg-12">Uid:</span>
              <span>{{ 'TRAC' + new Date().getTime() }}</span>
            </div>
          </el-card> -->
        </div>
      </div>

      <div class="header-mobile head-md">
        <div @click="refresh"><img height="45px" src="./assets/img/logo.png" alt=""></div>
        <ul v-if="!gameName1" class="ul-outer" style="font-size: 18px;text-decoration: none;">
          <li @click="openLogin">Login</li>
        </ul>
        <li class="info" @click="openInfo" v-if="gameName1">{{ gameName1 }}</li>
      </div>
    </div>

    <div :class="isad?'app-con':''">
      <router-view />
    </div>

    <div v-if="paytype" class="foot">
      <el-row :gutter="0">
        <el-col :xs="24" :sm="4" v-if="web">
          <div style="font-size:24px;margin:24px 0">HUAN SHENG</div>
          <div @click="gotourl('/contact')" class="foot-btn">Contact Us</div>
        </el-col>
        <el-col :xs="24" :sm="3">
          <div>
            <div class="foot-1">Company</div>
            <div class="foot-2">
              <p @click="gotourl('/')">Home</p>
              <p @click="gotourl('/aboutUs')">About Us</p>
              <p @click="gotourl('/games')">Games</p>
              <p @click="gotourl('/join')">Join</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="3">
          <div>
            <div class="foot-1">More</div>
            <div class="foot-2">
              <p @click="gotourl('/privacyPolicy')">Privacy Policy</p>
              <p @click="gotourl('/termsofUse')">Terms of Use</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="7">
          <div>
            <div class="foot-1">Contact Info</div>
            <div class="foot-2">
              <div>Address: Unit 9, 1st Floor, The Cloud, No.111 Tung Chau Street, Kowloon</div>
              <div style="margin-bottom:8px;">Email: information@huanshengfirst.com</div>
            </div>
          </div>
        </el-col>
        <!-- <el-col :xs="24" :sm="4">
          <div>
            <div v-if="web" class="foot-img2">
              <div class="icon-list">
                <div class="instagram" @click="gotoFaceBook('https://www.instagram.com')">
                  <img src="./assets/img/instagram.png" alt="">
                </div>
                <div class="facebook" @click="gotoFaceBook('https://www.facebook.com')">
                  <img src="./assets/img/facebook.png" alt="">
                </div>
                <div class="youtube" @click="gotoFaceBook('https://www.youtube.com')">
                  <img src="./assets/img/youtube.png" alt="">
                </div>
                <div class="tiktok" @click="gotoFaceBook('https://www.tiktok.com')">
                  <img src="./assets/img/tiktok.png" alt="">
                </div>
                <div class="linkedin" @click="gotoFaceBook('https://www.linkedin.com')">
                  <img src="./assets/img/linkedin.png" alt="">
                </div>
              </div>
            </div>
            <div v-else class="icon-list" style="display:flex;margin-bottom:18px;justify-content:space-evenly">
              <div class="instagram" @click="gotoFaceBook('https://www.instagram.com')">
                <img src="./assets/img/instagram.png" alt="">
              </div>
              <div class="facebook" @click="gotoFaceBook('https://www.facebook.com')">
                <img src="./assets/img/facebook.png" alt="">
              </div>
              <div class="youtube" @click="gotoFaceBook('https://www.youtube.com')">
                <img src="./assets/img/youtube.png" alt="">
              </div>
              <div class="tiktok" @click="gotoFaceBook('https://www.tiktok.com')">
                <img src="./assets/img/tiktok.png" alt="">
              </div>
              <div class="linkedin" @click="gotoFaceBook('https://www.linkedin.com')">
                <img src="./assets/img/linkedin.png" alt="">
              </div>
            </div>
          </div>
        </el-col> -->
      </el-row>
      <div class="foot-last">© 2025 HUAN SHENG TRADE LIMITED All Rights Reserved.
      </div>
    </div>

    <loginDialog ref="dialog"></loginDialog>
    <accountDialog ref="accountDialog"></accountDialog>

  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import loginDialog from './components/loginDialog/index.vue'
import accountDialog from './components/accountDialog/index.vue'
export default {
  name: 'app',
  data() {
    return {
      web: this.$utils.isDesktop(),
      id: '1',
      paytype: false,
      isad: null,
      headerList: [
        { label: 'Home', url: '/', id: "1" },
        { label: 'About us', url: '/aboutUs', id: "2" },
        { label: 'Games', url: '/games', id: "3" },
        { label: 'Join Us', url: '/join', id: "4" },
        { label: 'Privacy Policy', url: '/privacyPolicy', id: "5" },
        { label: 'Terms of Use', url: '/termsofUse', id: "6" },
        { label: 'Contact Us', url: '/contact', id: "7" },
      ],
      isRefresh: true,
      dialogVisible: false,
      isInfo: false,
      expireTime: '',

    }
  },
  components: { loginDialog, accountDialog },
  computed: {
    ...mapState({
      gameName1: state => state.user.gameName1,
    })
  },
  methods: {
    ...mapMutations(['getnumGame']),
    handleOpen() { },
    handleClose() { },
    openLogin() {
      this.$refs.dialog.show()
    },
    refresh() {
      this.$router.push('/')
      sessionStorage.setItem('numGame', '1')
      this.getnumGame()
    },
    gotourl(path, index) {
      this.id = index + 1
      this.$router.push(path)
    },
    gotoFaceBook(url) {
      window.open(url)
    },
    openInfo() {
      this.$refs.accountDialog.show()
    },
    tiemUp() {
      let gameName = sessionStorage.getItem('gameName')
      this.$axios.get(`/game/expire/time/getExpireTime/betadancegaming/${gameName}`).then((res) => {
        res = res.data
        this.expireTime = res.result.expireTime
        if (res.result.expireTime == '0') {
          sessionStorage.removeItem('isPay')
        }
      })
    },
  },
  beforeUpdate () {
    if (this.$route.path == '/callbackpay2' || this.$route.path == '/pay' || this.$route.path == '/payHtml/Failed'
      || this.$route.path == '/payHtml/Successful' || this.$route.path == '/payHtml/Paymentlinkhasexpired'
    ) {
      this.isad = ''
      this.paytype = false
    } else {
      this.isad = '1'
      this.paytype = true
    }
  },
  mounted() {
    let gameName = sessionStorage.getItem('gameName')
    if (gameName) {
      sessionStorage.setItem('isPay', 'pass')
      this.tiemUp()
    }
  },
}
</script>
<style lang="less">
.ul-outer {
  font-size: 14px;
  text-decoration: underline;
  display: flex;
  justify-content: center;
  align-items: center;

  li {
    margin-right: 32px;

    span {
      cursor: pointer;
      color: #fff;
      font-weight: 800;
    }
  }
}

.home-icon {
  width: 1260px;
  margin: 0 auto;

  .home-img {
    position: fixed;
    top: 20px;
    width: 66px;
    height: 66px;
    margin-left: -34px;
    border-radius: 50%;
    background: #ecf5ff;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
    }
  }
}

.logins {
  font-size: 18px;
  cursor: pointer;
  padding: 8px 20px;
  background: #14E085;
  border-radius: 8px;
  color: #000;
  font-family: 'PingFang';
  font-weight: bold;
}

.info {
  font-size: 22px;
  color: #FFF;
}

.head-shadow {
  position: fixed;
  z-index: 9999;
}

.app-con {
  min-height: calc(100vh - 360px - 50px);
  margin-top: 78px;
  /* background-color: #292929; */
}

.imgGames {
  width: 150px;
  position: absolute;
  right: 76px;
  bottom: 14px;
}

.header {
  font-family: 'aachenb';
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  top: 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url('./assets/img/new/tab.png');
  z-index: 9999;
  box-shadow: rgba(0, 0, 0, 0.03) 0px 0.14px 2.29266px, rgba(0, 0, 0, 0.05) 0px 0.37px 4.42626px, rgba(0, 0, 0, 0.09) 0px 3px 7px;
}

.icon-icons {
  display: flex;
  margin: 15px auto;
  justify-content: center;
  align-items: center;
}

.icon-baoder {
  width: 0px;
  height: 20px;
  border: 1px solid #FFF;
  margin-left: 15px;
}


.foot {
  background: #030E22;
  padding: 50px 0 80px 160px;
  color: #fff;
  font-family: 'aachenb';
}

.foot-1 {
  font-size: 22px;
  margin-bottom: 16px;
}

.foot-2 {
  font-size: 18px;

  p {
    cursor: pointer;
    margin-bottom: 6px;
  }

  p:hover {
    color: #14E085;
  }
}

.foot-last {
  text-align: center;
  background: rgb(59 67 90);
  position: absolute;
  width: 100%;
  left: 0;
  font-size: 20px;
  padding: 10px;
}

.ul-header li:last-of-type {
  padding: 6px 12px;
}

.foot-btn {
  background: #14E085;
  border-radius: 8px;
  width: 140px;
  text-align: center;
  line-height: 46px;
  color: #030E22;
  font-size: 22px;
  cursor: pointer;
}

.foot-img1 {
  display: flex;
  justify-content: space-evenly;
  margin: 30px 0;
}

.foot-img2 {
  margin-top: 26%;
  margin-left: 18%;

  img {
    margin-right: 12px;
  }
}

.icon-list {
  display: flex;

  img {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    margin-right: 18px;
  }
}

.expireTime {
  display: flex;
  color: #fff;
  font-size: 16px;

}

@media (width < 768px),
(min-resolution: 3dppx) and (width < 768px) {
  .icon-list img {
    margin-right: 0;
  }

  .app-con {
    min-height: auto;
    margin-top: 56px;
  }

  .foot {
    padding: 16px;
  }

  .foot-2 {
    border-bottom: 1px solid #ffffff;
    margin-bottom: 20px;
  }

  .foot-1 {
    margin-bottom: 10px;
    color: #2ea7ff;
  }

  .foot-last {
    font-size: 16px;
  }

  .info {
    margin-right: 14px;
  }

}

.header-mobile {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  top: 0;
  background-color: #0B0B0B !important;
  z-index: 9999;
  padding: 0px 4px 0 14px;

  .ul-outer {
    li {
      padding: 4px 8px;
      background: #14E085;
      border-radius: 8px;
      margin-right: 12px;

      span {
        color: #000;
        font-family: 'aachenb';
        font-size: 18px;
      }
    }
  }
}

.active {
  color: #14E085 !important;
  border-bottom: 1px solid;
}

.hoverActive:hover {
  color: #14E085 !important;
  border-bottom: 1px solid;
}

.box-card {
  position: absolute;
  top: 50px;
  right: 0;
  border-radius: 16px !important;
}

.mg-12 {
  margin-right: 12px;
}
</style>
